webpackJsonp([13],{

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(589),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e633720",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['companyId'],
  data: function data() {
    return {
      validationInfo: ''
    };
  },
  created: function created() {
    var _this = this;

    this.$http.post('company/validate/' + this.companyId, {}).then(function (res) {
      if (res.body.status === 'Success') {
        _this.validationInfo = res.body.details;
        return;
      }
      _this.err = res.body.statusText;
    }, function (err) {
      _this.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".close-btn[data-v-7e633720]{right:8px;top:8px}.card[data-v-7e633720]{height:auto;max-height:90%;overflow-y:auto}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/Validate.vue"],"names":[],"mappings":"AACA,4BACE,UAAW,AACX,OAAS,CACV,AACD,uBACE,YAAa,AACb,eAAgB,AAChB,eAAiB,CAClB","file":"Validate.vue","sourcesContent":["\n.close-btn[data-v-7e633720] {\n  right: 8px;\n  top: 8px;\n}\n.card[data-v-7e633720] {\n  height: auto;\n  max-height: 90%;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(530);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("60fb62ff", content, true, {});

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-5"
  }, [_c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), (_vm.validationInfo.errors) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "py-2": ""
    }
  }, _vm._l((_vm.validationInfo.errors), function(err, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "value": true,
        "type": "error"
      }
    }, [_vm._v(_vm._s(err))])
  }), 1) : _vm._e(), (_vm.validationInfo.warnings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "py-2": ""
    }
  }, _vm._l((_vm.validationInfo.warnings), function(warning, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "value": true,
        "type": "warning"
      }
    }, [_vm._v(_vm._s(warning))])
  }), 1) : _vm._e(), (_vm.validationInfo.infos) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "py-2": ""
    }
  }, _vm._l((_vm.validationInfo.infos), function(info, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "value": true,
        "type": "success"
      }
    }, [_vm._v(_vm._s(info))])
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.b8c54ff5e8ac8b0d6fab.js